import axios from "axios";
import store from "@/store";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getters["oauth/getAccessToken"];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401) {
      return Promise.reject(error);
    }

    if (originalRequest._retry) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    store.getters.currentUser.isAdmin ?
      await store.dispatch("oauth/adminTokenBySession") :
      await store.dispatch("oauth/tokenBySession", { companyId: store.getters.envCompanyId });

    return axiosInstance(originalRequest);

  },
);

export default axiosInstance;
